import { AccountingAccountTypeEnum } from '@zaoblako/shared/modules/catalog/enums/accounting-account-type.enum';
import {
  AccountDimensionSettingFindDto,
  type AccountDimensionSettingFindInterface,
} from '@zaoblako/shared/modules/catalog/dtos/account-dimension-setting/account-dimension-setting-find.dto';
import { Connection1cFindDto, type Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Accounting account response body - DTO signature */
export interface AccountingAccountFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Sub-account creation date and type */
  created: Date;
  /** Sub-account last update date and type */
  updated: Date;
  /** Sub-account soft deletion date and type */
  deleted?: Date;
  /** Account unique code */
  code: string;
  /** Account quick selection code (sanitized {@link AccountingAccountEntity.code} value) */
  quickSelectionCode: string;
  /** Account display name */
  name: string;
  /** Account type */
  type: AccountingAccountTypeEnum;
  /** Analytic dimension settings for this account */
  dimensions?: AccountDimensionSettingFindInterface[];
  /** Related 1C ERP databases */
  connections?: Connection1cFindInterface[];
}

/** Accounting account response body - DTO schema */
export const AccountingAccountFindDto = SerdeDtoClass.create<AccountingAccountFindInterface>(CatalogDtosKeysEnum.ACCOUNTING_ACCOUNT_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удален',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Наименование счета',
    serializer: yup.string(),
  },
  code: {
    sortable: true,
    label: 'Код счета',
    serializer: yup.string(),
  },
  type: {
    sortable: true,
    label: 'Тип счета',
    serializer: yup
      .string()
      .oneOf(Object.values(AccountingAccountTypeEnum)),
  },
  quickSelectionCode: {
    sortable: true,
    label: 'Быстрый набор',
    serializer: yup.string(),
  },
  dimensions: {
    optional: true,
    label: 'Субконто',
    nested: AccountDimensionSettingFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  connections: {
    optional: true,
    label: 'Базы 1С',
    nested: Connection1cFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
});
